// extracted by mini-css-extract-plugin
export default {"Waveform":"XpmrYSXEzMouGfze_m66"};